import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  manager: null,
  defaultFileStatus: null,
  defaultFolders: null,
  availableStatuses: null,
  registryRights: [],
  table: {
    search: "",
    limit: 11,
    page: 1,
    pages: 1,
    sort: "",
    data: [],
    searchFields: [
      { key: "name", name: "global:contacts.name" },
      { key: "NIP", name: "global:contacts.nip" },
      { key: "city", name: "global:contacts.city" },
      { key: "street", name: "global:contacts.street" },
      { key: "phoneNumber", name: "global:contacts.phoneNumber" },
    ],
    selectedSearchFields: ["name", "NIP", "city", "street", "phoneNumber"],
    dictionaryFields: [],
    url: "contact",
  },
};

const contactsReducer = createSlice({
  name: "contactReducer",
  initialState,
  reducers: {
    setRegistryRights: (state, { payload }) => {
      state.registryRights = payload;
    },
    updateManager: (state, { payload }) => {
      state.manager = payload;
    },
    updateDefaultFileStatus: (state, { payload }) => {
      state.defaultFileStatus = payload;
    },
    updateDefaultFolders: (state, { payload }) => {
      state.defaultFolders = payload;
    },
    updateAvailableStatuses: (state, { payload }) => {
      state.availableStatuses = payload;
    },
    updateRegistry: (state, { payload }) => {
      state.table = { ...state.table, ...payload };
    },
    clearRegistry: () => initialState,
  },
  extraReducers: {},
});

export const {
  updateRegistry,
  clearRegistry,
  updateManager,
  updateDefaultFileStatus,
  updateDefaultFolders,
  updateAvailableStatuses,
  setRegistryRights,
} = contactsReducer.actions;

export default contactsReducer.reducer;
